import Controller from "./extraInformation.controller";
import template from "./extraInformation.html";

const extraInformation = {
  template,
  controller: Controller,
  bindings: {
    title: "@",
    items: "<",
    resourceMethodName: "@",
    updateEvent: "<",
    successUpdateEvent: "=",
  },
};

export default extraInformation;



// WEBPACK FOOTER //
// ./src/components/extraInformation/extraInformation.component.js